import axios from 'axios';
import env from '../env/env.js'

export function Propio(nombre) {
    var cadena = nombre.toLowerCase().split(' ');
    for (var i = 0; i < cadena.length; i++) {
        cadena[i] = cadena[i].charAt(0).toUpperCase() + cadena[i].substring(1);
    }
    nombre = cadena.join(' ');
    return nombre;
}

export function clubMensaje() {
    return "<b>Queridos alumnos</b>," +
        "<br>" +
        "<br>" +
        "Tengo el inmenso placer de anunciar que este año, el <b>Club de las Eminencias</b> abrirá sus puertas a <b>nuevos y prometedores talentos.</b>" +
        "<br>" +
        "<br>" +
        "Este selecto grupo <i>—como muchos ya sabrán—</i> reúne a los estudiantes más destacados, brillantes y prometedores de Hogwarts. Pero ingresar en él no es tarea sencilla… requiere esfuerzo, ingenio y, sobre todo, <b>pasión por sobresalir.</b>" +
        "<br>" +
        "<br>" +
        "Por ello, <b>invito a todos los alumnos</b> a esforzarse a lo largo del año escolar, pues aquellos que acumulen <b>la mayor cantidad de puntos</b> <i>—sí, puntos reales, otorgados por méritos académicos, conducta ejemplar y habilidades excepcionales—</i> podrán acceder a este círculo privilegiado." +
        "<br>" +
        "<br>" +
        "<b>Y atención:" +
        "<br>" +
        "<br>" +
        "Los tres estudiantes con más puntos al final del año</b> no solo recibirán la distinción de ingresar al Club, sino que también serán recompensados con un <b>premio sin igual.</b> No puedo revelar demasiado, pero digamos que está a la altura de un futuro prometedor…" +
        "<br>" +
        "<br>" +
        "Así que afilen sus plumas, agiten sus varitas y den lo mejor de sí." +
        "<br>" +
        "<br>" +
        "El Club de las Eminencias <b>espera a sus futuros miembros.</b>" +
        "<br>" +
        "<br>" +
        "Con afecto y mucha expectativa," +
        "<br>" +
        "<br>" +
        "<b>Horace E. F. Slughorn</b>" +
        "<br>" +
        "<br>" +
        "Fundador del Club de las Eminencias" +
        "<br>" +
        "<br>" +
        "Cultivador de Grandes Destinos" +
        "<br>" +
        "<br>";
}

export function copaMensaje() {
    return "La Copa de las Casas es un premio anual de Hogwarts. Es dada al final del año a la casa con más puntos obtenidos. Los puntos son dados por los profesores y prefectos en todo el año por responder correctamente preguntas y por buenas obras.";
}

export function validarCorreo(email) {
    if (email == null) {
        return false;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
}

export function validaContraseña(contrasena, contraseñaV, validacion) {
    switch (validacion) {
        case "1":
            if (contrasena.length < 10) {
                return false;
            }
            break;
        case "2":
            if (contrasena != contraseñaV) {
                return false;
            }
            break;
    }
    return true;
}

export async function sendMail(to, subject, mensaje) {
    try {
        const response = await axios.post(env.getDomain() + 'smail', {
            to: to,
            subject: subject,
            text: mensaje
        });

        return response.data;

    } catch (error) {
        console.error('Error al iniciar sesión:', error);
        return { error: true, message: error.message };
    }
}